module.exports = __webpack_public_path__ + "static/media/payment-methods.accb4616.svg";